import PropTypes from "prop-types";
import styles from "../../index.css";
import addUpSellCarousel from "../../addUpSellCarousel";
import addAdvert from "../../addAdvert";
import addPromoTile from "./addPromoTile";
import getFocusTileIndex from "../../getFocusTileIndex";
import mapProductsToProductTiles from "../../mapProductsToProductTiles";

const ListingPage = ({
  isInitialPage,
  page: { products, pageNumber },
  focusFirstTile,
  focusLastTile,
  advert,
  promoTile,
  upSellCarousel,
  ...rest
}) => {
  const focusTileIndex = getFocusTileIndex({
    focusFirstTile,
    focusLastTile,
    products
  });

  let items = mapProductsToProductTiles({
    products,
    focusTileIndex,
    isInitialPage,
    pageNumber,
    ...rest
  });

  if (pageNumber === 1) {
    items = addPromoTile({ promoTile, items });
  }

  let adPosition = null;

  ({ adPosition, items } = addAdvert({
    advert,
    items
  }));
  items = addUpSellCarousel({
    upSellCarousel,
    items,
    adPosition
  });

  return (
    <section className={styles.listingPage} data-auto-id={pageNumber}>
      {items}
    </section>
  );
};

ListingPage.propTypes = {
  isInitialPage: PropTypes.bool.isRequired,
  page: PropTypes.shape({
    products: PropTypes.arrayOf(PropTypes.object).isRequired,
    pageNumber: PropTypes.number
  }),
  focusFirstTile: PropTypes.bool.isRequired,
  focusLastTile: PropTypes.bool.isRequired,
  advert: PropTypes.func,
  promoTile: PropTypes.shape({
    component: PropTypes.func.isRequired,
    position: PropTypes.number.isRequired
  }),
  upSellCarousel: PropTypes.func
};

export default ListingPage;
